<template>
  <div>
    <div></div>
    <!-- Profit Loss Approval Modal Start -->
    <b-button
      style="font-size: 0.675rem"
      class="mt-2"
      size="sm"
      @click="PL_pl_approved_flag == 0 ? CommonPLPanel(PLPanelDetail) : ''"
      :variant="PL_pl_approved_flag == 0 ? 'danger' : 'success'"
    >
      <b>{{ PL_is_pl_approved }}</b> </b-button
    ><br />
    <span
      v-if="PL_pl_approved_flag == 1 && PL_pl_approved_remark"
      v-html="PL_pl_approved_remark"
      >{{ wordWrap(PL_pl_approved_remark, 24) }}</span
    ><br />
    <span v-if="PL_pl_approved_flag == 1 && PL_pl_approved_date">{{
      PL_pl_approved_date
    }}</span>
    <b-modal
      id="Common_modal-PL-conf"
      ref="Common_modal-PL-conf"
      :title="PL_title + PL_JOBNO"
      size="lg"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <div class="row">
        <div class="col-md-2 text-right">
          <label for="ColumnName">Remark :</label>
        </div>
        <div class="col-md-10 mt-2">
          <b-form-textarea
            :formatter="capitalizeAll"
            rows="5"
            id="name-input"
            v-model="PLPanelDetail.pl_approved_remark"
            required
          ></b-form-textarea>
        </div>

        <div class="col-md-12 text-center">
          <center>
            <b-button
              v-if="PLPanelDetail.pl_approved_remark"
              :disabled="
                PLPanelDetail.pl_approved_remark && PLPanelDetail.lock_button
                  ? false
                  : !PLPanelDetail.pl_approved_remark && PLPanelDetail.lock_button
                  ? true
                  : false
              "
              variant="success"
              style="font-size: 11px"
              size="sm"
              class="mt-2"
              @click="CommonConfLock"
              >Save</b-button
            >
            <b-button
              @click="CommoncloseCommonPLPanelConfirm"
              style="font-size: 11px"
              size="sm"
              class="mt-2"
              variant="danger"
              >Close</b-button
            >
          </center>
        </div>
      </div>
    </b-modal>
    <!-- Assignment Summary Modal End -->
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { DateFormat, selectDateFormat, wordWrap } from "../../helper/filters";
import ProfitLossService from "../../services/ProfitLossService.js";

export default {
  props: {
    PL_title: {
      type: String,
      default: "",
    },
    PL_JOBID: {
      type: String,
      default: "",
    },
    PL_JOBNO: {
      type: String,
      default: "",
    },
    PL_JOBDATE: {
      type: String,
      default: "",
    },
    PL_JOBTYPE: {
      type: String,
      default: "",
    },
    PL_Client: {
      type: String,
      default: "",
    },
    PL_Sline: {
      type: String,
      default: "",
    },
    PL_is_pl_approved: {
      type: String,
      default: "",
    },
    PL_pl_approved_flag: {
      type: String,
      default: 0,
    },
    PL_pl_approved_date: {
      type: String,
      default: "",
    },
    PL_pl_approved_remark: {
      type: String,
      default: "",
    },
  },
  beforeMount() {
    if (this.PL_JOBID != "" && this.Filter_Flag == true) {
      this.getServicesData();
      this.getAssignmentMultiUpdate();
    }
  },

  data() {
    return {
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      Filter_Flag: false,

      PLPanelDetail: {
        JOBID: this.PL_JOBID,
        JOBNO: this.PL_JOBNO,
        JOBTYPE: this.JOBTYPE,
        is_pl_approved: this.PL_is_pl_approved,
        pl_approved_date: this.PL_pl_approved_date,
        pl_approved_remark: this.PL_pl_approved_remark,
        lock_button: true,
      },
    };
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    Loading,
  },

  computed: {},
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getData();
      },
      deep: true,
    },
  },
  methods: {
    wordWrap,
    CommonConfLock() {
      if (this.PLPanelDetail.pl_approved_remark) {
        this.isLoading = true;
        let tit = "";
        this.PLPanelDetail.lock_button = true;
        let payload = {};
        payload = {
          itemCode: "approveProfitLossDash",
          PLPanelDetail: this.PLPanelDetail,
        };
        ProfitLossService.getAllProfitLoss(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data.JOBPLFLAG == 1) {
              this.CommoncloseCommonPLPanelConfirm();
              this.alert.content = data.JOBPLMSG;
              this.$refs["addPop"].open();
              this.PLPanelDetail.pl_approved_remark = "";
              this.$refs["Common_modal-PL-conf"].hide();
              this.PLPanelDetail.lock_button = false;
              this.isLoading = false;
              eventBus.$emit("plApprovalComp", data.Commrow);
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on JOBList Error: ", error);
          });
      }
    },
    CommonPLPanel(items) {
      this.$refs["Common_modal-PL-conf"].show();
    },
    CommoncloseCommonPLPanelConfirm() {
      this.$refs["Common_modal-PL-conf"].hide();
    },
  },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>



// WEBPACK FOOTER //
// plApprovalCom.vue?51f6db2d